<template>
  <div class="w-full mt-5 relative">
    <!-- <span
      v-if="inputValue !== placeholder"
      class="absolute pointer-events-none left-5 py-0 -top-3 px-5 bg-white text-xs text-newGray capitalize"
    >
      {{ placeholder }}
    </span> -->
    <input
      style="background-color: #f3f3f3"
      class="focus:border-primary focus:ring-primary border-dark-200 p-16 bg-white w-full text-info-700 font-medium text-sm leading-2 focus:outline-none border-0 rounded-2xl py-3 px-4 block appearance-none rounded-2xl mt-1 mb-5"
      :type="inputType"
      :value="inputValue"
      @mouseover="hidePlaceholder"
      :max="inputType === 'date' ? max : undefined"
      :min="inputType === 'date' ? min : undefined"
      @blur="showPlaceholder"
      @input="updateValue"
      :placeholder="placeholder"
    />
    <span
      class="custom-icon"
      v-if="inputValue === placeholder && useTime === false"
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.00008 10.668C9.1649 10.668 9.32602 10.6191 9.46306 10.5275C9.6001 10.436 9.70691 10.3058 9.76998 10.1535C9.83305 10.0013 9.84956 9.83371 9.8174 9.67206C9.78525 9.51041 9.70588 9.36192 9.58934 9.24538C9.47279 9.12884 9.32431 9.04947 9.16266 9.01731C9.00101 8.98516 8.83345 9.00166 8.68118 9.06474C8.52891 9.12781 8.39876 9.23462 8.30719 9.37166C8.21562 9.5087 8.16675 9.66982 8.16675 9.83464C8.16675 10.0556 8.25455 10.2676 8.41083 10.4239C8.56711 10.5802 8.77907 10.668 9.00008 10.668ZM13.1667 10.668C13.3316 10.668 13.4927 10.6191 13.6297 10.5275C13.7668 10.436 13.8736 10.3058 13.9366 10.1535C13.9997 10.0013 14.0162 9.83371 13.9841 9.67206C13.9519 9.51041 13.8725 9.36192 13.756 9.24538C13.6395 9.12884 13.491 9.04947 13.3293 9.01731C13.1677 8.98516 13.0001 9.00166 12.8478 9.06474C12.6956 9.12781 12.5654 9.23462 12.4739 9.37166C12.3823 9.5087 12.3334 9.66982 12.3334 9.83464C12.3334 10.0556 12.4212 10.2676 12.5775 10.4239C12.7338 10.5802 12.9457 10.668 13.1667 10.668ZM9.00008 14.0013C9.1649 14.0013 9.32602 13.9524 9.46306 13.8609C9.6001 13.7693 9.70691 13.6391 9.76998 13.4869C9.83305 13.3346 9.84956 13.167 9.8174 13.0054C9.78525 12.8437 9.70588 12.6953 9.58934 12.5787C9.47279 12.4622 9.32431 12.3828 9.16266 12.3506C9.00101 12.3185 8.83345 12.335 8.68118 12.3981C8.52891 12.4611 8.39876 12.568 8.30719 12.705C8.21562 12.842 8.16675 13.0032 8.16675 13.168C8.16675 13.389 8.25455 13.6009 8.41083 13.7572C8.56711 13.9135 8.77907 14.0013 9.00008 14.0013ZM13.1667 14.0013C13.3316 14.0013 13.4927 13.9524 13.6297 13.8609C13.7668 13.7693 13.8736 13.6391 13.9366 13.4869C13.9997 13.3346 14.0162 13.167 13.9841 13.0054C13.9519 12.8437 13.8725 12.6953 13.756 12.5787C13.6395 12.4622 13.491 12.3828 13.3293 12.3506C13.1677 12.3185 13.0001 12.335 12.8478 12.3981C12.6956 12.4611 12.5654 12.568 12.4739 12.705C12.3823 12.842 12.3334 13.0032 12.3334 13.168C12.3334 13.389 12.4212 13.6009 12.5775 13.7572C12.7338 13.9135 12.9457 14.0013 13.1667 14.0013ZM4.83341 10.668C4.99823 10.668 5.15935 10.6191 5.29639 10.5275C5.43343 10.436 5.54024 10.3058 5.60331 10.1535C5.66639 10.0013 5.68289 9.83371 5.65074 9.67206C5.61858 9.51041 5.53921 9.36192 5.42267 9.24538C5.30613 9.12884 5.15764 9.04947 4.99599 9.01731C4.83434 8.98516 4.66678 9.00166 4.51451 9.06474C4.36224 9.12781 4.23209 9.23462 4.14052 9.37166C4.04896 9.5087 4.00008 9.66982 4.00008 9.83464C4.00008 10.0556 4.08788 10.2676 4.24416 10.4239C4.40044 10.5802 4.6124 10.668 4.83341 10.668ZM14.8334 2.33464H14.0001V1.5013C14.0001 1.28029 13.9123 1.06833 13.756 0.912046C13.5997 0.755766 13.3878 0.667969 13.1667 0.667969C12.9457 0.667969 12.7338 0.755766 12.5775 0.912046C12.4212 1.06833 12.3334 1.28029 12.3334 1.5013V2.33464H5.66675V1.5013C5.66675 1.28029 5.57895 1.06833 5.42267 0.912046C5.26639 0.755766 5.05443 0.667969 4.83341 0.667969C4.6124 0.667969 4.40044 0.755766 4.24416 0.912046C4.08788 1.06833 4.00008 1.28029 4.00008 1.5013V2.33464H3.16675C2.50371 2.33464 1.86782 2.59803 1.39898 3.06687C0.93014 3.53571 0.666748 4.17159 0.666748 4.83464V14.8346C0.666748 15.4977 0.93014 16.1336 1.39898 16.6024C1.86782 17.0712 2.50371 17.3346 3.16675 17.3346H14.8334C15.4965 17.3346 16.1323 17.0712 16.6012 16.6024C17.07 16.1336 17.3334 15.4977 17.3334 14.8346V4.83464C17.3334 4.17159 17.07 3.53571 16.6012 3.06687C16.1323 2.59803 15.4965 2.33464 14.8334 2.33464V2.33464ZM15.6667 14.8346C15.6667 15.0556 15.579 15.2676 15.4227 15.4239C15.2664 15.5802 15.0544 15.668 14.8334 15.668H3.16675C2.94573 15.668 2.73377 15.5802 2.57749 15.4239C2.42121 15.2676 2.33341 15.0556 2.33341 14.8346V7.33464H15.6667V14.8346ZM15.6667 5.66797H2.33341V4.83464C2.33341 4.61362 2.42121 4.40166 2.57749 4.24538C2.73377 4.0891 2.94573 4.0013 3.16675 4.0013H14.8334C15.0544 4.0013 15.2664 4.0891 15.4227 4.24538C15.579 4.40166 15.6667 4.61362 15.6667 4.83464V5.66797ZM4.83341 14.0013C4.99823 14.0013 5.15935 13.9524 5.29639 13.8609C5.43343 13.7693 5.54024 13.6391 5.60331 13.4869C5.66639 13.3346 5.68289 13.167 5.65074 13.0054C5.61858 12.8437 5.53921 12.6953 5.42267 12.5787C5.30613 12.4622 5.15764 12.3828 4.99599 12.3506C4.83434 12.3185 4.66678 12.335 4.51451 12.3981C4.36224 12.4611 4.23209 12.568 4.14052 12.705C4.04896 12.842 4.00008 13.0032 4.00008 13.168C4.00008 13.389 4.08788 13.6009 4.24416 13.7572C4.40044 13.9135 4.6124 14.0013 4.83341 14.0013Z"
          fill="#8B8B8B"
        />
      </svg>
    </span>
  </div>
</template>

<script setup>
import { ref, watch, computed, onMounted } from "vue";

const props = defineProps({
  placeholder: {
    type: String,
  },
  max: {
    type: String,
  },
  min: {
    type: String,
  },
  value: {
    type: String,
    default: "",
  },
  useTime: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(["update"]);
const watchProp = computed(() => props.placeholder);
const watchValue = computed(() => props.value);
const inputType = ref("text");
const inputValue = ref("");

inputValue.value = watchValue.value;

watch(
  watchProp,
  watchValue,
  () => {
    inputValue.value = props.value ? props.value : props.placeholder;
  },
  { immediate: true }
);

const showPlaceholder = () => {
  if (inputValue.value === "") {
    inputType.value = "text";
    inputValue.value = props.value ? props.value : props.placeholder;
  }
};

const hidePlaceholder = () => {
  if (inputValue.value === props.placeholder) {
    inputType.value = props.useTime ? "time" : "date";
    inputValue.value = props.value;
  }
};

const updateValue = (event) => {
  inputValue.value = event.target.value;
  emit("update", inputValue.value);
};

onMounted(() => {
  inputValue.value = props.value ? props.value : props.placeholder;
});
</script>

<style scoped>
.custom-icon {
  position: absolute;
  right: 10px;
  top: 40%;
  transform: translateY(-50%);
  display: inline-block;
  font-size: 20px;
  opacity: 0.7;
}
input[type="date"]::-webkit-calendar-picker-indicator {
  content: ""; /* FontAwesome calendar icon */
  font-family: "FontAwesome";
  position: absolute;
  right: 10px;
  top: 40%;
  transform: translateY(-50%);
  font-size: 18px;
  color: #333;
  background-image: url("https://svgshare.com/i/wRH.svg");
  background-size: cover;
}
</style>
